<template>
  <div class="presentation-cover">
    <div
      v-if="backgroundImage"
      class="presentation-cover__background-image"
      :style="backgroundImageStyle"
      aria-hidden="true"
    ></div>

    <div class="presentation-cover__wrapper">
      <div class="presentation-cover__content">
        <slot />
      </div>
      <PresentationCoverFooter>
        <template #corner>
          <slot name="corner" />
        </template>
      </PresentationCoverFooter>
    </div>
  </div>
</template>

<script>
import PresentationCoverFooter from '@/views/MasterPresentation/PresentationCoverFooter';

export default {
  name: 'PresentationCover',

  components: {
    PresentationCoverFooter,
  },

  props: {
    backgroundImage: {
      type: String,
      default: null,
    },
  },

  computed: {
    backgroundImageStyle() {
      return {
        backgroundImage: `url('${this.backgroundImage}')`,
      };
    },
  },
};
</script>
